module.exports = __webpack_public_path__ + "static/media/041.4167e5fe.jpg";